import React, { ReactElement, useRef, useState } from "react";
import { Tooltip } from "../Tooltip/Tooltip";
import styles from "./SuiteCardImageFooterWithTooltip.module.scss";
import { SuiteCardImageFooter } from "./SuiteCardBase";
import clsx from "clsx";
import { Button } from "../Button/Button";

type Props = {
  label: string;
  buttonLabel: string;
  details: ReactElement;
};

export const SuiteCardImageFooterWithTooltip: React.FC<Props> = ({
  label,
  buttonLabel,
  details
}) => {
  const referenceElement = useRef<HTMLDivElement>(null);
  const [showTooltip, setShowTooltip] = useState(false);
  const onClick = () => setShowTooltip((x) => !x);
  const onClose = () => setShowTooltip(false);
  return (
    <SuiteCardImageFooter
      content={
        <div className={styles.content}>
          <div>{label}</div>
          <div ref={referenceElement}>
            <Button
              size="small"
              variant="link"
              onClick={onClick}
              onKeyDown={onClick}
              className={clsx(styles.button, {
                [styles.buttonShowTooltip]: showTooltip
              })}
              renderAs="button"
              dataContentPiece="tooltip"
            >
              {buttonLabel}
            </Button>
          </div>
        </div>
      }
    >
      <Tooltip
        referenceElement={referenceElement}
        onClose={onClose}
        show={showTooltip}
        width={200}
      >
        {details}
      </Tooltip>
    </SuiteCardImageFooter>
  );
};
